__turbopack_context__.v({
  "questionCardRadio": "styles-module-scss-module__fCOghq__questionCardRadio",
  "questionCardRadio__card": "styles-module-scss-module__fCOghq__questionCardRadio__card",
  "questionCardRadio__error": "styles-module-scss-module__fCOghq__questionCardRadio__error",
  "questionCardRadio__errorSlot": "styles-module-scss-module__fCOghq__questionCardRadio__errorSlot",
  "questionCardRadio__grid": "styles-module-scss-module__fCOghq__questionCardRadio__grid",
  "questionCardRadio__icon": "styles-module-scss-module__fCOghq__questionCardRadio__icon",
  "questionCardRadio__input": "styles-module-scss-module__fCOghq__questionCardRadio__input",
  "questionCardRadio__label": "styles-module-scss-module__fCOghq__questionCardRadio__label",
});
